import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { IRouter } from '../../../shared/interfaces/router.interface';

@Component({
  selector: 'app-month-sales',
  templateUrl: 'month-sales.component.html',
  styleUrls: ['month-sales.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MonthSalesComponent implements OnInit {
  @Input() label: string;
  @Input() total: string;
  @Input() route: IRouter;

  constructor() {}

  ngOnInit() {}
}
